var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFarmershop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6913 23.5391V43.1532H30.5074M9.30859 23.5391V43.1532H19.8087M19.8087 43.1532V33.5252C24.0882 29.2457 25.7912 29.0514 30.5074 33.5252V43.1532M19.8087 43.1532H30.5074",
    stroke: "#28882B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15419 15.4782C5.65415 19.3628 8.54754 23.5429 12.7117 23.5429V23.5429C15.9615 23.5429 18.6141 20.9084 18.6141 17.6587V17.6587V17.6587C18.6141 20.9084 21.2486 23.5429 24.4984 23.5429H25.4971C28.7469 23.5429 31.3813 20.9084 31.3813 17.6587V17.6587V17.6587C31.3813 20.9084 34.035 23.5429 37.2847 23.5429V23.5429C41.4511 23.5429 44.3473 19.3603 42.846 15.4739L39.9014 7.85156H10.0992L7.15419 15.4782Z",
    stroke: "#00AF20",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmershop);
export default __webpack_public_path__ + "static/media/farmershop.abfeb00055393f790baa38eff46f2df9.svg";
export { ForwardRef as ReactComponent };